const orgAccesssTypes = {
    SELF_SERVICE: 'self service',
    SINGLE_SIGN_ON: 'single sign-on',
    API: 'api',
    AUTO_ASSIGN: 'auto assign',
    PHONE: 'phone'
};
Object.freeze(orgAccesssTypes);
export default orgAccesssTypes;